// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { productSelectorStyles } from "@rpsc/Overrides/Components/ProductSelector";
import { color, hideElement, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const btnStyles: ButtonPresentationProps = {
    variant: "tertiary",
    css: css`
        min-height: 33px;
        white-space: nowrap;
        ${xScreen("lte", "sm")} {
            width: 100%;
            max-width: 100%;
        }
    `,
};

productSelectorStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        gap: 12px;
        flex-wrap: wrap;
        align-items: flex-end;
    `,
};

productSelectorStyles.searchFieldWrapper = {
    css: css`
        width: 305px;
        position: relative;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

productSelectorStyles.searchDynamicDropdown = {
    iconProps: {
        css: css`
            display: none;
        `,
    },
};

productSelectorStyles.qtyTextField = {
    cssOverrides: {
        formField: css`
            width: 50px;
        `,
        inputSelect: css`
            font-size: 14px;
            line-height: 19px;
            text-align: center;
        `,
    },
};

productSelectorStyles.clearIcon = {
    size: 18,
    css: css`
        position: absolute;
        right: 9px;
        top: 35px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

productSelectorStyles.unitOfMeasureSelect = {
    cssOverrides: {
        formField: css`
            width: 91px;
            ${xScreen("lte", "md")} {
                width: 103px;
            }
        `,
    },
};

productSelectorStyles.selectButton = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        max-height: 33px;
        ${xScreen("lte", "md")} {
            max-width: 127px;
        }
    `,
};

productSelectorStyles.extraButtonsWrapper = {
    css: css`
        margin-left: auto;
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            margin-left: 0;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        &:empty {
            ${hideElement}
        }
    `,
};

productSelectorStyles.orderUploadButton = {
    ...mergeWithCss(btnStyles, {
        css: css`
            max-width: 146px;
        `,
    }),
};

productSelectorStyles.orderMultipleItemsButton = {
    ...btnStyles,
};

productSelectorStyles.errorMessage = {
    color: "danger",
};

productSelectorStyles.errorWrapper = {
    css: css`
        width: 100%;
    `,
};
